// extracted by mini-css-extract-plugin
export default {"preparing":"Preparing_preparing__QG4OE","timerContainer":"Preparing_timerContainer__AFhsS"};